import request from '@/utils/request'

const addressURl = {
    List: '/branch-office-address/list',
    Create: '/branch-office-address/create',
    staffSearchList: 'branch-office-address/staff-search',
    addressUpdate: '/branch-office-address/update',
    addressView: '/branch-office-address/view',
    addressDel: '/branch-office-address/delete',
    companyList: '/branch-office-address-v2/list',
    getCityList: '/public/area',
    companyCreate: '/branch-office-address-v2/create',
    companyUpdate: '/branch-office-address-v2/update',
    companyAddressDel: '/branch-office-address-v2/delete'
}

// 公司地址管理
export function companyList(data) {
    return request({
        url: addressURl.companyList,
        method: 'post',
        data
    })
}

export function getCityList(data) {
    return request({
        url: addressURl.getCityList,
        method: 'post',
        data
    })
}

// 添加地址
export function companyAddressCreate(data) {
    return request({
        url: addressURl.companyCreate,
        method: 'post',
        data
    })
}

// 更新地址
export function companyAddressUpdate(data) {
    return request({
        url: addressURl.companyUpdate,
        method: 'post',
        data
    })
}

// 删除
export function companyAddressDel(data) {
  return request({
      url: addressURl.companyAddressDel,
      method: 'post',
      data
  })
}

// 分公司列表
export function addressList(data) {
    return request({
        url: addressURl.List,
        method: 'post',
        data
    })
}

// 添加公司
export function addressCreate(data) {
    return request({
        url: addressURl.Create,
        method: 'post',
        data
    })
}

// 负责人列表
export function staffSearchList(data) {
    return request({
        url: addressURl.staffSearchList,
        method: 'post',
        data
    })
}
// 更新
export function addressUpdate(data) {
    return request({
        url: addressURl.addressUpdate,
        method: 'post',
        data
    })
}

// 详情
export function addressView(data) {
    return request({
        url: addressURl.addressView,
        method: 'post',
        data
    })
}

// 删除
export function addressDel(data) {
  return request({
      url: addressURl.addressDel,
      method: 'post',
      data
  })
}
export default {
    addressList,
    addressCreate,
    staffSearchList,
    addressUpdate,
    addressView,
    addressDel,
    companyList,
    getCityList,
    companyAddressCreate,
    companyAddressUpdate,
    companyAddressDel
}
